import type { ReactElement, SVGAttributes } from 'react';
import { twMerge } from 'cn';

/** Link `<Badge>` icon. */
export const Badge = ({ className, ...props }: SVGAttributes<SVGElement>): ReactElement => (
  <svg
    className={twMerge('h-[50px] w-[50px] fill-success', className)}
    viewBox='0 0 50 50'
    {...props}
  >
    <path d='M25,0L25,0c13.8,0,25,11.2,25,25l0,0c0,13.8-11.2,25-25,25l0,0C11.2,50,0,38.8,0,25l0,0C0,11.2,11.2,0,25,0z' />
    <path
      className='fill-light'
      d='M26,32.8c0.4,0.4,0.4,1,0,1.4l-2.1,2.1c-1.4,1.3-3.2,2-5,2c0,0,0,0-0.1,0c-1.9,0-3.7-0.8-5.1-2.1
        c-1.4-1.4-2.1-3.1-2.1-5.1c0-1.9,0.7-3.7,2-5.1l3.8-3.8c0.7-0.7,1.6-1.3,2.6-1.7c1-0.4,2-0.5,3.1-0.4c1,0.1,2,0.4,3,0.9
        c0.9,0.5,1.7,1.2,2.3,2c0.3,0.4,0.2,1.1-0.2,1.4c-0.4,0.3-1.1,0.2-1.4-0.2c-0.5-0.6-1-1.1-1.7-1.5c-0.7-0.4-1.4-0.6-2.1-0.6
        c-0.8-0.1-1.5,0.1-2.2,0.3c-0.7,0.3-1.3,0.7-1.9,1.2L15,27.5c-1,1-1.5,2.3-1.5,3.7c0,1.4,0.6,2.7,1.5,3.7c1,1,2.3,1.5,3.7,1.5
        c1.4,0,2.7-0.5,3.7-1.5l2.1-2.1C25,32.4,25.6,32.4,26,32.8z M36.3,13.7c-1.4-1.4-3.2-2.1-5.1-2.1c0,0,0,0-0.1,0c-1.9,0-3.7,0.7-5,2
        L24,15.8c-0.4,0.4-0.4,1,0,1.4c0.4,0.4,1,0.4,1.4,0l2.1-2.1c1-1,2.3-1.5,3.6-1.5c0,0,0,0,0,0c1.4,0,2.7,0.6,3.7,1.5s1.5,2.3,1.5,3.7
        c0,1.4-0.5,2.7-1.5,3.7l-3.8,3.8c-0.5,0.5-1.2,0.9-1.9,1.2c-0.7,0.3-1.5,0.4-2.2,0.3c-0.8-0.1-1.5-0.3-2.1-0.6
        c-0.7-0.4-1.2-0.9-1.7-1.5c-0.3-0.4-1-0.5-1.4-0.2c-0.4,0.3-0.5,1-0.2,1.4c0.6,0.8,1.4,1.5,2.3,2c0.9,0.5,1.9,0.8,3,0.9
        c0.2,0,0.3,0,0.5,0c0.9,0,1.7-0.2,2.5-0.5c1-0.4,1.9-0.9,2.6-1.7l3.8-3.8c1.3-1.4,2.1-3.2,2-5.1C38.4,16.9,37.7,15.1,36.3,13.7z'
    />
  </svg>
);
